// @flow

import React from "react";
import { localize } from "redux-i18n";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Col,
  SchemaForm,
  TooltipDropdown,
} from "@components";
import uiSchema from "./ui-schema";
import "./styles.scss";
import { getSchema } from "@utils/schema";

const schema = getSchema("AbsenceDocumentDTO");

type Props = $Exact<{
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  ...PropsFromLocalize,
}>;

export class AddAbsenceDocumentModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (form: Object) => {
    this.props.onSubmit(form);
  };

  get uiSchema() {
    return uiSchema(this.props.t);
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("ADD_DOCUMENT")}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={schema}
            onSubmit={this.handleSubmit}
            uiSchema={this.uiSchema}
            formData={null}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="upload_file" onClick={this.submitForm}>
            {this.props.t("UPLOAD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddAbsenceDocumentModal);
